import ClearIcon from "@mui/icons-material/Clear";
import { FormControl } from "@mui/material";
import { AnimatePresence } from "framer-motion";
import { useContext, useEffect, useMemo, useState } from "react";
import ReactSelect from "react-select";
import CloseIcon from "../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import ModalConfirmacao from "../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../components/ModalUsuario/ModalUsuario.tsx";
import TabelaV2 from "../../../components/TabelaV2/TabelaV2";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../contexts/RequestController";
import TabelaRedux from "../../../contexts/Tabela";
import MotionContainer from "../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import Layout from "../../../core/layout/Layout.tsx";
import { getRotaDependencias } from "../../../services/ModuloGerenciador/Geral.ts";
import {
	cadastraRota,
	deleteRotaPorId,
	editaRotaPorId,
	getRota,
	getRotaPorId,
} from "../../../services/ModuloGerenciador/Rota";
import "./Rota.css";

function Rota(props) {
	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { profile, hasRegra, tabelaEmpresa } = useProfile();

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [valuesSelect, setValuesSelect] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState({});

	const [valuesAbreviacao, setValuesAbreviacao] = useState({});

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [listaCidades, setListaCidades] = useState([]);

	const [listaCidadesCompleta, setListaCidadesCompleta] = useState([]);

	const [cidadeDestinoValido, setCidadeDestinoValido] = useState(true);

	const [cidadeOrigemValido, setCidadeOrigemValido] = useState(true);

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const title = useMemo(() => {
		if (editando) return "Detalhes de Rota";
		if (telaCadastro) return "Cadastro de Rota";
		return "Rotas";
	}, [editando, telaCadastro]);

	const buscarDependencias = async () => {
		setLoading(true);
		await getRotaDependencias(profile?.token)
			.then((result) => {
				setListaCidades(result.data.cidadeEstados);
				setListaCidadesCompleta(result.data.cidadeEstados);
				setDadosTabela(result.data.rotas);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 3000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarRota = async () => {
		setLoading(true);
		await getRota(profile?.token).then((result) => {
			setDadosTabela(result.data);
			setTabelaRedux({});
			setLoading(false);
		});
	};

	const cadastrar = async () => {
		if (values.cidadeDestinoId && values.cidadeOrigemId) {
			setLoading(true);
			await cadastraRota(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						buscarRota();
						setDadosRequestControllerRedux("Fechar Modal Rota");
						setTabelaRedux({});
						setValuesAbreviacao({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
						setValues({});
						setValuesSelect({});
						setValuesAbreviacao({});
						setTelaCadastro(false);
						if (!!props.onCloseModal) {
							props.onCloseModal();
						}
					}
				})
				.catch((error) => {
					if (error.response.status !== 200) {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			if (!values.cidadeDestinoId) {
				setCidadeDestinoValido(false);
			}
			if (!values.cidadeOrigemId) {
				setCidadeOrigemValido(false);
			}
			setOpenToastErro(true);
			setTextoErro("Há campos sem preencher");
		}
	};

	const editar = async () => {
		if (values.cidadeDestinoId && values.cidadeOrigemId) {
			setLoading(true);
			await editaRotaPorId(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						buscarRota();
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
						setTelaCadastro(false);
						setEditando(false);
						setValues({});
						setValuesSelect({});
						setValuesAbreviacao({});
						if (!!props.onCloseModal) {
							props.onCloseModal();
						}
					}
				})
				.catch((error) => {
					if (error.response.status !== 200) {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setOpenToastErro(true);
			setTextoErro("Há campos sem preencher");
		}
	};

	const buscarRotaPorId = async () => {
		setLoading(true);
		await getRotaPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						const nome = result.data.nome;
						const nomeSplit1 = nome.split("X")[0];
						const nomeSplit2 = nome.split("X")[1];
						const { cidadeOrigem, estadoOrigem, cidadeDestino, estadoDestino } =
							result.data;
						const setSelectValue = (cidade, estado, field) => {
							const selectedOption = opcoesCidadeEstado.find(
								(option) => option.cidade === cidade && option.estado === estado
							);
							if (selectedOption) {
								setValuesSelect((current) => ({
									...current,
									[field]: selectedOption,
								}));
							}
						};
						setSelectValue(cidadeOrigem, estadoOrigem, "cidadeOrigem");
						setSelectValue(cidadeDestino, estadoDestino, "cidadeDestino");
						setValues(result.data);
						setValuesAbreviacao((current) => ({
							...current,
							abreviacao1: nomeSplit1,
						}));
						setValuesAbreviacao((current) => ({
							...current,
							abreviacao2: nomeSplit2,
						}));
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarRotaPorIdModal = async (id) => {
		setLoading(true);
		await getRotaPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					const nome = result.data.nome;
					const nomeSplit1 = nome.split("X")[0];
					const nomeSplit2 = nome.split("X")[1];
					const { cidadeOrigem, estadoOrigem, cidadeDestino, estadoDestino } =
						result.data;
					const setSelectValue = (cidade, estado, field) => {
						const selectedOption = opcoesCidadeEstado.find(
							(option) => option.cidade === cidade && option.estado === estado
						);
						if (selectedOption) {
							setValuesSelect((current) => ({
								...current,
								[field]: selectedOption,
							}));
						}
					};
					setSelectValue(cidadeOrigem, estadoOrigem, "cidadeOrigem");
					setSelectValue(cidadeDestino, estadoDestino, "cidadeDestino");
					setValues(result.data);
					setValuesAbreviacao((current) => ({
						...current,
						abreviacao1: nomeSplit1,
					}));
					setValuesAbreviacao((current) => ({
						...current,
						abreviacao2: nomeSplit2,
					}));
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarRotaPorId = async () => {
		setLoading(true);
		await deleteRotaPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarRota();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		if (editando) {
			buscarRotaPorId();
		}
	}, [editando]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			buscarDependencias();
			setSemAutorizacao(!hasRegra("Rota"));
		}
	}, [profile?.token]);

	useEffect(() => {
		if (props.idAtual) {
			buscarRotaPorIdModal(props.idAtual);
		}
	}, [listaCidades]);

	useEffect(() => {
		if (props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const labelCidadeEstadoOrigem = (data) => (
		<div style={{ display: "flex", alignItems: "center" }}>
			{data.cidade} - {data.estado}
			{values.cidadeOrigem === data.cidade && (
				<ClearIcon
					className="info-icon"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						clearCidadeEstadoOrigem();
					}}
				/>
			)}
		</div>
	);

	const labelCidadeEstadoDestino = (data) => (
		<div style={{ display: "flex", alignItems: "center" }}>
			{data.cidade} - {data.estado}
			{values.cidadeDestino === data.cidade && (
				<ClearIcon
					className="info-icon"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						clearCidadeEstadoDestino();
					}}
				/>
			)}
		</div>
	);

	const clearCidadeEstadoOrigem = () => {
		if (valuesAbreviacao.abreviacao1 && valuesAbreviacao.abreviacao2) {
			setValues((current) => ({ ...current, nome: "" }));
		}
		setValues((current) => ({
			...current,
			cidadeOrigemId: null,
			cidadeOrigem: "",
			estadoOrigem: "",
			nome: "",
		}));
		setValuesAbreviacao((current) => ({
			...current,
			abreviacao1: "",
		}));
		setValuesSelect((current) => ({ ...current, cidadeOrigem: "" }));
	};

	const clearCidadeEstadoDestino = () => {
		if (valuesAbreviacao.abreviacao1 && valuesAbreviacao.abreviacao2) {
			setValues((current) => ({ ...current, nome: "" }));
		}
		setValues((current) => ({
			...current,
			cidadeDestinoId: null,
			cidadeDestino: "",
			estadoDestino: "",
			nome: "",
		}));
		setValuesAbreviacao((current) => ({
			...current,
			abreviacao2: "",
		}));
		setValuesSelect((current) => ({ ...current, cidadeDestino: "" }));
	};

	const estiloCidadeEstado = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			border: "none",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
			zIndex: 1400,
		}),
		menuPortal: (provided) => ({
			...provided,
			zIndex: 1400,
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
		}),
	};

	const customStylesErro = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			border: "none",
			borderRadius: "7px",
			border: "1px solid red",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
			zIndex: 1400,
		}),
		menuPortal: (provided) => ({
			...provided,
			zIndex: 1400,
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const opcoesCidadeEstado = listaCidades.map((data) => ({
		value: data.idCidadeEstado,
		label: `${data.cidade} - ${data.estado}`,
		...data,
	}));

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer key="RotaScreenContainer">
						<div className="content-container">
							<TabelaV2
								setTelaCadastro={setTelaCadastro}
								setEditando={setEditando}
								classeSelecionado="idRota"
								nomeClasse1="outer-wrapper-v2"
								nomeClasse2="table-v2-center"
								colunas={tabelaEmpresa.Rota}
								nome="rota"
								dados={dadosTabela}
								isLoading={loading}
							/>
						</div>
						<div className="footer-space-between">
							<div>
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Cadastrar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setTelaCadastro(true);
										setEditando(false);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-editar"
									classText="button-texto-editar"
									titulo="Editar"
									icone="iconeEdit"
									cor="#CDCDCD"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setTelaCadastro(true);
											setEditando(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Deletar"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setOpen(true);
											setTextoSucesso("Deletado Com Sucesso");
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
							<div>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Obter Usuário"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenUsuario(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
						</div>
					</MotionContainer>
				) : (
					<MotionContainer key="RotaCadastroScreenContainer">
						<div className="content-container">
							{!props.desabilitar && (
								<div className="texto-cadastro-container">
									{props.botaoFechar !== false && (
										<div style={{ width: 29, height: 29 }} />
									)}
									<div className="indicador">
										<p className="indicador-emb">{"Dados de Rota / "}</p>
										{editando ? (
											<p className="indicador-emb">{"Detalhes de Rota"}</p>
										) : (
											<p className="indicador-emb">{"Cadastro de Rota"}</p>
										)}
									</div>
									{props.botaoFechar !== false && (
										<div className="close-btn">
											<CloseIcon
												onClick={() => {
													setValues({});
													setValuesSelect({});
													setValuesAbreviacao({});
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
												}}
											/>
										</div>
									)}
								</div>
							)}
							<div className="flex-column">
								<div className="container-select-emb">
									<div className="rota-div-2">
										<div className={
											cidadeOrigemValido ? "coluna-emb" : "coluna-emb-erro"
										} style={{ padding: 12 }}>
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Cidade/Estado Origem:
												</p>
												<FormControl sx={{ width: 250 }}>
													<ReactSelect
														value={valuesSelect.cidadeOrigem}
														isDisabled={props.desabilitar}
														options={opcoesCidadeEstado}
														formatOptionLabel={labelCidadeEstadoOrigem}
														styles={
															cidadeOrigemValido ? estiloCidadeEstado : customStylesErro
														}
														menuPortalTarget={document.body}
														placeholder=""
														noOptionsMessage={() => "Não há mais opções"}
														onChange={(selectedOption) => {
															setCidadeOrigemValido(true);
															if (
																valuesAbreviacao.abreviacao1 &&
																valuesAbreviacao.abreviacao2
															) {
																setValues((current) => ({
																	...current,
																	nome: `${valuesAbreviacao.abreviacao1} X ${valuesAbreviacao.abreviacao2}`,
																}));
															}
															if (selectedOption) {
																setValues((current) => ({
																	...current,
																	cidadeOrigemId: selectedOption.idCidadeEstado,
																	cidadeOrigem: selectedOption.cidade,
																	estadoOrigem: selectedOption.estado,
																	nome: "",
																}));
																setValuesAbreviacao((current) => ({
																	...current,
																	abreviacao1: `${selectedOption.abreviacao} - ${selectedOption.estado}`,
																}));
																setValuesSelect((current) => ({
																	...current,
																	cidadeOrigem: selectedOption,
																}));
															}
														}}
													/>
												</FormControl>
												{!cidadeOrigemValido && (
													<div className="error-text">Obrigatório!</div>
												)}
											</div>
										</div>
										<div className={
											cidadeDestinoValido ? "coluna-emb" : "coluna-emb-erro"
										} style={{ padding: 12 }}>
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Cidade/Estado Destino:
												</p>
												<FormControl sx={{ width: 250 }}>
													<ReactSelect
														value={valuesSelect.cidadeDestino}
														isDisabled={props.desabilitar}
														options={opcoesCidadeEstado}
														formatOptionLabel={labelCidadeEstadoDestino}
														styles={
															cidadeDestinoValido ? estiloCidadeEstado : customStylesErro
														}
														menuPortalTarget={document.body}
														placeholder=""
														noOptionsMessage={() => "Não há mais opções"}
														onChange={(selectedOption) => {
															if (selectedOption) {
																setCidadeDestinoValido(true);
																if (
																	valuesAbreviacao.abreviacao1 &&
																	valuesAbreviacao.abreviacao2
																) {
																	setValues((current) => ({
																		...current,
																		nome: `${valuesAbreviacao.abreviacao1} X ${valuesAbreviacao.abreviacao2}`,
																	}));
																}
																setValues((current) => ({
																	...current,
																	cidadeDestinoId:
																		selectedOption.idCidadeEstado,
																	cidadeDestino: selectedOption.cidade,
																	estadoDestino: selectedOption.estado,
																	nome: "",
																}));
																setValuesAbreviacao((current) => ({
																	...current,
																	abreviacao2: `${selectedOption.abreviacao} - ${selectedOption.estado}`,
																}));
																setValuesSelect((current) => ({
																	...current,
																	cidadeDestino: selectedOption,
																}));
															}
														}}
													/>
												</FormControl>
												{!cidadeDestinoValido && (
													<div className="error-text">Obrigatório!</div>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="footer-container">
							{editando ? (
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Salvar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										editar();
									}}
								/>
							) : (
								<>
									{!props.desabilitar ? (
										props.botaoCadastrar ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													cadastrar();
												}}
											/>
										) : (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													cadastrar();
												}}
											/>
										)
									) : (
										<></>
									)}
								</>
							)}
							{props.botaoVoltar ? (
								<></>
							) : (
								<CustomButtonV2
									classCss="custom-button-cancelar"
									classText="button-texto-cancelar"
									titulo="Cancelar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setValues({});
										setValuesSelect({});
										setValuesAbreviacao({});
										setTelaCadastro(false);
										setEditando(false);
										setTabelaRedux({});
									}}
								/>
							)}
						</div>
					</MotionContainer>
				)}
			</AnimatePresence>
			<div>
				<ModalConfirmacao
					titulo="Deletar"
					texto="Deseja Deletar?"
					tituloConfirmar="Confirmar"
					tituloCancelar="Cancelar"
					open={open}
					onClose={handleClose}
					onClick={deletarRotaPorId}
				/>
				<ModalUsuario
					titulo="Usuário"
					tituloConfirmar="OK"
					open={openUsuario}
					onClose={handleCloseUsuario}
				/>
			</div>
			<div>
				<ToastSucesso
					texto={textoSucesso}
					open={openToastSucesso}
					onClose={handleCloseToastSucesso}
				/>
				<ToastErro
					texto={textoErro}
					open={openToastErro}
					onClose={handleCloseToastErro}
				/>
			</div>
		</Layout>
	);
}

export default Rota;
